var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1197_21690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2708 52.7994C41.8509 52.7994 53.6705 40.9798 53.6705 26.3997C53.6705 11.8195 41.8509 0 27.2708 0C12.6906 0 0.871094 11.8195 0.871094 26.3997C0.871094 40.9798 12.6906 52.7994 27.2708 52.7994Z",
    fill: "url(#paint0_linear_1197_21690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1042 15.7092H18.4393C14.9736 15.7092 12.1641 18.5188 12.1641 21.9845V30.8152C12.1641 34.281 14.9737 37.0905 18.4393 37.0905H36.1042C39.57 37.0905 42.3795 34.2809 42.3795 30.8152V21.9845C42.3795 18.5188 39.5699 15.7092 36.1042 15.7092ZM31.8602 26.8295L23.5979 30.77C23.3776 30.8751 23.1232 30.7148 23.1232 30.4709V22.3433C23.1232 22.0958 23.3843 21.9354 23.6048 22.0473L31.8671 26.2342C32.1131 26.3587 32.1087 26.7111 31.8602 26.8295Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1197_21690",
    x1: 27.2708,
    y1: 0,
    x2: 27.2708,
    y2: 52.7994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F32313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A01F15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1197_21690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.7994,
    height: 52.7994,
    fill: "white",
    transform: "translate(0.871094)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e78cdac70ca3ff14cb38c1d2e5364581.svg";
export { ForwardRef as ReactComponent };